import React from 'react'
import InstancesCatalogFilter from '../../__filter/_instancesCatalog/catalog__filter_instancesCatalog'
import EditableText from 'blocks.simple/editableText/editableText'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import styles from '../_instancesCatalog/catalog__template_instancesCatalog.jcss'
import { ItemData } from '../../../../core/models/Template'

export default {
    getMethod: 'getTeachers',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noTeachers'),
    emptyDescription: () => translate('noTeachersDescription'),
    emptyIcon: 'not_allow',
    disableDrag: true,
    addItemButton: () => null,
    settingsPrefixes: 'teachers',
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'name', name: translate('byNameAsc') },
    ],
    headerFilters: (p_: any) => (
        <InstancesCatalogFilter
            onAdd={() => p_.onAddFakeLine({ name: '' })}
            title={translate('teachers')}
            type="teacher"
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem: { id: number }) => selectedItem.id)
                if (id.length > 0) {
                    api.send('deleteTeacher', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
            {...p_}
        />
    ),
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item: ItemData) => {
        return api.send('getTeacher', { id: item.id }, { hideLoader: true })
    },
    tableWrapper: styles.tableWrapper,
    isEqual: (firstItem: ItemData, secondItem: ItemData) => firstItem.id === secondItem.id,
    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('teacherCreated', cb, clearList)],
    onUpdateListeners: [(cb: any, clearList: string[]) => api.addObserver('teacherUpdated', cb, clearList)],
    onDeleteListeners: [(cb: any, clearList: string[]) => api.addObserver('teacherDeleted', cb, clearList)],
    isFolder: () => {},
    fields: () => [{ id: 'name', name: translate('name') }],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        name: (p_: { id: number; name: string }, active: boolean, listProps: any) => (
            <EditableText
                id={p_.id}
                text={p_.name}
                onCreate={(name) => api.send('createTeacher', { name })}
                onUpdate={(name, cb) => {
                    api.send('updateTeacher', { name, id: p_.id }).then(cb)
                }}
                onSaveEmpty={function () {
                    listProps.onAddFakeLine()
                }}
            />
        ),
    },
    hideActiveRowColor: true,
    disableUpdateUserSettings: true,
    onDeleteListItem: (listItem: { id: number }) => {
        api.send('deleteTeacher', { id: listItem.id })
    },
    fixedColWidth: true,
}
